import GlobeMark from "./GlobeMark";

const NAV_LINKS = [
  { label: "Who we serve", href: "#who", external: false },
  { label: "What we set up", href: "#scope", external: false },
  { label: "How we work", href: "#how", external: false },
  { label: "The people", href: "#people", external: false },
];

export default function Header() {
  return (
    <header className="site-header" id="top" data-testid="site-header">
      <div className="container header-inner">
        <a
          className="brand"
          href="#top"
          data-testid="brand-link"
          aria-label="Global Citizen Consulting, Family Office Practice, back to top"
        >
          <GlobeMark />
          <span className="brand-text">
            <span className="brand-name">Global Citizen Consulting</span>
            <span className="brand-sub">Family Office</span>
          </span>
        </a>
        <nav className="header-nav" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              className="nav-link"
              href={link.href}
              data-testid={`nav-link-${link.href.slice(1)}`}
            >
              {link.label}
            </a>
          ))}
          <a
            className="nav-link"
            href="https://insights.globalcitizenconsult.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-link-insights"
          >
            Insights ↗
          </a>
        </nav>
        <a
          className="btn btn-secondary header-cta"
          href="#invite"
          data-testid="header-cta-button"
        >
          Request a conversation
        </a>
      </div>
    </header>
  );
}
